const initModals = () => {
  MicroModal.init({
    onShow: modal => toggleBodyOverflowHidden(),
    onClose: modal => setTimeout(toggleBodyOverflowHidden, 300),
    awaitCloseAnimation: true,
  });
}
